<template lang="pug">
    div
        Steps(:current="batchStep" style="margin-bottom: 20px")
            Step(v-for="(stepInfo, index) in batchStepData" :title="stepInfo.title" :content="stepInfo.content" :key="index")

        // 選擇要編輯的物件 
        component(
            v-show="batchStep == 0"
            :is="batchSelector"
            :selector="batchSelectorWith"
            v-model="batchSelectedData"
            v-bind="{givenSearchFilters: givenBatchSearchFilters}"
            :esIndex="esIndex"
            :action="action")

        // 清除緩存路徑
        Row(v-show="batchStep == 1")
            Form(:model="batchFormData")
                FormItem(label="Clear Cache Path")
                    Input(
                        v-model="batchFormData.clearCachePath"
                        :placeholder="confirmData.placeHolder"
                    )

        // 使用者確認
        Row(v-show="batchStep == 2")
            Col(span="11")
                Card
                    p(slot="title") Selected {{ batchSelectedData.selectedItems.length }} Items
                    p(v-for="item in batchSelectedData.selectedItems") {{ item }}
            Col(span="11" offset="2")
                Card
                    p(slot="title") Clear Cache Path
                    p {{ batchFormData.clearCachePath }}

        // 功能鍵
        .footer
            Button(v-show="batchStep !== 0" style="width:45%" @click="changeBatchFormStep('prev')") Prev
            Button(v-if="batchStep !== 2" style="width:45%; float: right" @click="changeBatchFormStep('next')" :disabled="batchStepData[batchStep].isNextBtnDisabled()" ) Next
            Button(v-else style="width:45%; float: right" type="primary" @click="submitForm" :loading="isBtnLoading") {{ $t("rcmtable.submitText") }}
                
</template>
<script>
import FQDNSelector from "@/components/FQDNSelector.vue";

import { batchStepDataCompletion } from "@/libs/rcmTableFieldsFunction";

import { purgeCache } from "@/api/edges";

export default {
    components: {
        FQDNSelector,
    },
    props: {
        esIndex: { type: String, default: "" },
        batchSelector: { type: String, default: "" },
        givenBatchSearchFilters: { type: Array, default: () => [] },
        batchSelectorWith: {},
        batchClearCachePage: { type: String, default: "" },
    },
    data() {
        return {
            isBtnLoading: false,
            // 批次表單內容表單
            batchFormData: {
                clearCachePath: "",
            },

            // 要批次修改的物件
            batchSelectedData: {
                selectedGroupName: "",
                selectedItems: [],
            },

            batchStep: 0,
            batchStepData: [
                {
                    title: "Select Items",
                    content: "Select the items to purge cache",
                    isNextBtnDisabled: () => !this.hasSelectedItems,
                },
                {
                    title: "Clear path",
                    content: "The path for clearing cache",
                },
                { title: "Confirm", content: "Confirm the changes" },
            ],
            action: "batchClear",    
            confirmData: {
                placeHolder: "指定清除路徑, 空白全部清除. 例如: /assets/template/",
                actionSuccessText: "清除成功",
                actionFalseText: "清除失敗",
            },
        };
    },
    created() {},
    mounted() {
        // 補上預設值
        this.initBatchStepData();
    },
    watch: {},
    methods: {
        initBatchStepData() {
            this.batchStepData = this.batchStepData.map((data) => batchStepDataCompletion(data));
        },
        async changeBatchFormStep(step) {
            if (step == "next") {
                // 執行驗證與 beforeNextStep 功能
                let passValidate = await this.batchStepData[this.batchStep].validateBeforeNextStep();

                if (passValidate) {
                    this.batchStepData[this.batchStep].beforeNextStep();
                    this.batchStep += 1;
                }
            } else {
                this.batchStep -= 1;
            }

            // 執行 enter 功能
            this.batchStepData[this.batchStep].enter();
        },
        submitForm() {
            this.isBtnLoading = true;
            let purgeItems = this.batchSelectedData.selectedItems.map((e) => {
                return {
                    fqdnConfig: e,
                    key: this.batchFormData.clearCachePath,
                };
            });
            let purgeData = {
                groupName: this.batchSelectedData.selectedGroupName,
                isAppProfile: this.batchClearCachePage == "appProfile" ? true : false,
                purgeItems: purgeItems,
            };
            purgeCache(purgeData)
                .then((response) => {
                    this.isBtnLoading = false;

                    this.$Message.success(this.confirmData.actionSuccessText);
                    this.$emit("batchSubmitComplete");
                })
                .catch((error) => {
                    console.log(error);
                    this.isBtnLoading = false;

                    this.$Message.error(this.confirmData.actionFalseText);
                    this.$emit("batchSubmitComplete");
                });
        },
    },
    computed: {
        hasSelectedItems() {
            return this.batchSelectedData.selectedItems.length !== 0;
        },
    },
};
</script>
<style lang="less" scoped>
.footer {
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    padding: 15px 16px;
    text-align: left;
    background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/BatchClearCacheForm.vue